// App Initialisation
export const LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS =
  "LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS";
export const RESET_INITIALISATION_SIMILAR_ITEMS =
  "RESET_INITIALISATION_SIMILAR_ITEMS";
export const RECEIVE_SIMILAR_ITEMS = "RECEIVE_SIMILAR_ITEMS";

// Action
export const RECEIVE_SEE_SIMILAR_PRODUCT_ID = "RECEIVE_SEE_SIMILAR_PRODUCT_ID";
export const SIMILAR_ITEMS_INITIALISATION_FAILURE =
  "SIMILAR_ITEMS_INITIALISATION_FAILURE";
